module.exports = __webpack_public_path__ + "files/dc1ad7e3645fef4a609361fd24069989.png";